
import { ref, computed, defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import { KhoService } from "@/core/services/Kho.service";
import { useStore } from "vuex";
import { getErrorMsg, swalNotification } from "@/core/helpers/utils";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { IKhoResponseBase } from "@/core/interfaces/ApiResponses";
import { useLoading } from "@/core/hooks/use-loading";
import { usePageHeader } from "@/core/hooks/usePageHeader";
import { KHO } from "@/core/constants/permissions";

import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import DanhSachKhoTable from "@/views/crafted/pages/kho/danh-sach-kho-table/DanhSachKhoTable.vue";

export default defineComponent({
  name: "warehouses",

  components: {
    PageContentBase,
    DanhSachKhoTable,
  },

  setup() {
    const { push } = useRouterCustom();
    const router = useRouter();
    const { startLoading, setLoading, endLoading } = useLoading();
    const store = useStore();
    const khoItems = ref<IKhoResponseBase[]>([]);
    document.title = "Danh sách kho - Đường sắt Hà Nội";

    const handleBack = () => {
      if (window.history.length > 1) {
        router.go(-1);
      } else {
        router.push({ name: "dashboard" });
      }
    };

    const { searchQuery } = usePageHeader({
      title: "Danh sách kho",
      breadcrumbs: [{ text: "Kho" }],
      subtitle: "Quản lý thông tin và tình trạng hoạt động của các kho hàng",
      showBack: true,
      showSearch: true,
      searchPlaceholder: "Tìm kiếm kho...",
      addLabel: "Thêm kho",
      addPermissions: [KHO.TAO_MOI],
      backgroundUrl: "media/page-topics/warehouse.png",
      onAdd: () => push("/quan-ly/kho/tao-moi"),
      onBack: handleBack,
    });

    const filteredItems = computed(() => {
      const query = searchQuery.value.trim().toLowerCase();
      if (!query) {
        return khoItems.value;
      }

      return khoItems.value.filter((item) => {
        const haystack = [item.ma_kho, item.ten_kho, item.dia_chi]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(query);
      });
    });

    const fetchData = async () => {
      startLoading();
      try {
        const {
          data: {
            data: { data: khoItemsResponse },
          },
        } = await KhoService.fetchAllWarehousesByDepartmentId(
          store.getters.currentUser.departmentId
        );
        khoItems.value = khoItemsResponse;
        endLoading();
      } catch (err) {
        endLoading();
        await swalNotification(
          getErrorMsg(err, "Có lỗi xảy ra khi lấy danh sách kho"),
          "error"
        );
      }
    };

    onMounted(async () => {
      await fetchData();
    });

    return {
      khoItems,
      searchQuery,
      filteredItems,
      push,
      startLoading,
      setLoading,
      endLoading,
      fetchData,
    };
  },
});
